<app-back-header-atom
  icon="arrow-left"
  text="Détails de la commande"
  (navigationClick)="back()"
></app-back-header-atom>
